import { createReducer } from '@reduxjs/toolkit'
import { takeEvery, call, put } from 'redux-saga/effects'
import Axios from 'axios'
import { axiosConfig } from './common/axiosConfig'
import { USER } from './actionTypes'

// Actions
export function loginSuccess(tokenId) {
    return {
        type: USER.LOGIN.SUCCESS,
        payload: {
            tokenId
        }
    }
}

export function logout() {
    return { type: USER.LOGOUT }
}

// Reducers
const initialState = {
    user: undefined,
    loading: false
}

export const userReducer = createReducer(initialState, {
    [USER.GET.REQUEST]: (state) => {
        state.loading = true
    },
    [USER.GET.SUCCESS]: (state, action) => {
        state.loading = false
        state.user = action.payload
    },
    [USER.LOGOUT]: (state) => {
        state.user = undefined
        state.loading = false
    }
})

// Sagas
function* loginFlowSaga(action) {
    try {
        // login
        const {
            data: { session, userId }
        } = yield call(Axios.post, `/login/google`, action.payload, axiosConfig())

        // get user data
        yield put({ type: USER.GET.REQUEST })

        const { data } = yield call(Axios.get, `/users/${userId}`, axiosConfig(session))

        yield put({ type: USER.GET.SUCCESS, payload: data })

        localStorage.setItem('session', session)
        localStorage.setItem('userId', userId)
    } catch (e) {
        // TODO display error to user
        yield handleLogout()
    }
}

function* handleLogout() {
    localStorage.removeItem('userId')
    localStorage.removeItem('session')
    yield
}

export function* userSaga() {
    yield takeEvery(USER.LOGIN.SUCCESS, loginFlowSaga)
}

// Selectors
export const selectIsLoggedIn = (state) => {
    return !!state.user.user && !!localStorage.getItem('session')
}

export const selectUser = (state) => state.user.user
